<div class="histogram-wrapper fw fh">
  @if (!data?.length) {
    <div class="no-data fw fh"
      >
      <span>{{'common.no_data_small' | translate}}.</span>
    </div>
  }
</div>